<!-- =========================================================================================
  File Name: DataListListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
<div id="data-list-list-view" class="data-list-container">

    <data-view-sidebar @updateParentImage="parentImageUpdated" :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData" v-if="addNewDataSidebar" />

    <vs-table v-if="permissions_list" ref="table" pagination :max-items="itemsPerPage" search :data="filter_customers">

        <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

            <div class="flex flex-wrap-reverse items-center data-list-btn-container">

                <!-- ADD NEW -->
                <vs-button :size="largeScreenWidth ? '' : 'small' " color="primary" type="filled" @click="addNewData" v-if="permissions_create" icon="icon-plus" icon-pack="feather">{{largeScreenWidth ? 'Add New' : 'Add' }}</vs-button>
                <!-- <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary btn-sm" @click="addNewData" v-if="permissions_create">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
          </div> -->
                <vs-select autocomplete v-model="gender" v-if="user_info.role == 'DEVELOPER'">
                    <vs-select-item value="all" text="All" />
                    <vs-select-item value="female" text="Female" />
                    <vs-select-item value="male" text="Male" />
                    <vs-select-item value="dev" text="Dev Acc" />
                </vs-select>
            </div>

            <!-- ITEMS PER PAGE -->
            <vs-dropdown :disabled="filter_customers.length == 0" vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
                <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span v-if="filter_customers.length > 0" class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ filter_customers.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : filter_customers.length }} of {{ queriedItems }}</span>
                    <span v-else>0 of 0</span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                </div>
                <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
                <vs-dropdown-menu>
                    <vs-dropdown-item @click="itemsPerPage=10">
                        <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=15">
                        <span>15</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=20">
                        <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="itemsPerPage=25">
                        <span>25</span>
                    </vs-dropdown-item>
                </vs-dropdown-menu>
            </vs-dropdown>
        </div>

        <template slot="thead">
            <vs-th sort-key="groupid">Group</vs-th>
            <vs-th>Image</vs-th>
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="idno">ID No</vs-th>
            <vs-th sort-key="contact">Contact</vs-th>
            <vs-th sort-key="status">Status</vs-th>
            <vs-th sort-key="updated_at">Last Updated</vs-th>
            <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{data}">
            <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                    <vs-td>
                        <p class="groupid">{{ formatGroup(tr.groupid) }}</p>
                    </vs-td>

                    <vs-td>
                        <img v-if="checkFlag(tr.pictures)" :src="checkImageUrl(tr.pictures)" style="max-height: 400px; height: auto; width:100%" />
                        <!-- <vs-input class="w-full" ref="uploadbtn" label-placeholder="借贷人像" type="file" accept="image/*" @change="getImage($event, tr.uuid)" /> -->
                        <input v-else ref="uploadbtn" type="file" accept="image/*" name="uploadbtn" class="selectedFile" @change="getImage($event, tr.uuid)" />
                    </vs-td>

                    <vs-td>
                        <p class="name font-medium truncate">{{ tr.name }}</p>
                    </vs-td>

                    <vs-td>
                        <p class="idno">{{ tr.idno }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="contact">{{ tr.contact }}</p>
                    </vs-td>
                    <vs-td>
                        <p class="status">
                            <vs-chip :color="tr.status == 'ACTIVE' ? 'primary' : 'danger'">{{ tr.status }}</vs-chip>
                        </p>
                    </vs-td>

                    <vs-td>
                        <p class="updated_at">{{ formatDate(tr.updated_at) }}</p>
                    </vs-td>

                    <vs-td class="whitespace-no-wrap">
                        <feather-icon v-if="permissions_update" icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
                        <feather-icon style="color: red;" class="ml-4" v-if="permissions_update" icon="TrashIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="deleteCustomer(tr)" />
                    </vs-td>
                </vs-tr>
            </tbody>
        </template>
    </vs-table>
    <h5 v-else>Not allowed to view customer list</h5>
</div>
</template>

<script>
import DataViewSidebar from './sidebar.vue'
// Store Module

import moduleCustomerManagement from '@/store/customer-management/moduleCustomerManagement.js'

import axios from 'axios'

export default {
    components: {
        DataViewSidebar,
    },
    data() {
        return {
            // selected: [],
            // users: [],
            itemsPerPage: 10,
            isMounted: false,

            // Data Sidebar
            addNewDataSidebar: false,
            sidebarData: {},
            // customers: []
            gender: 'all',
        }
    },
    computed: {
        largeScreenWidth() {
            if (window.innerWidth > 575) {
                return true
            } else
                return false
        },
        currentPage() {
            if (this.isMounted) {
                return this.$refs.table.currentx
            }
            return 0
        },
        filter_customers() {
            if (this.user_info.role == 'DEVELOPER') {
                if (this.gender == 'all') {
                    return this.$store.state.customerManagement.customers
                } else if (this.gender == 'female') {
                    let temp = []
                    this.$store.state.customerManagement.customers.forEach(function (item) {
                        if (item.idno.length > 11) {
                            if (parseInt((item.idno).slice(-1)) % 2 == 0) {
                                temp.push(item)
                            }
                        }
                    })
                    return temp
                } else if (this.gender == 'male') {
                    let temp = []
                    this.$store.state.customerManagement.customers.forEach(function (item) {
                        if (item.idno.length > 11) {
                            if (parseInt((item.idno).slice(-1)) % 2 !== 0) {
                                temp.push(item)
                            }
                        }
                    })
                    return temp
                } else if (this.gender == 'dev') {
                    let temp = []
                    this.$store.state.customerManagement.customers.forEach(function (item) {
                        if (item.idno.length < 11) {
                            temp.push(item)
                        }
                    })
                    return temp
                }
            } else {
                return this.$store.state.customerManagement.customers
            }
        },
        permissions() {
            if (this.$store.state.AppActiveUser && this.$store.state.AppActiveUser.permissions) {
                return this.$store.state.AppActiveUser.permissions;
            } else {
                return []
            }
        },
        permissions_create() {
            if (this.permissions.includes('*') || this.permissions.includes('021')) {
                return true
            } else {
                return false
            }
        },
        permissions_list() {
            if (this.permissions.includes('*') || this.permissions.includes('022')) {
                return true
            } else {
                return false
            }
        },
        permissions_update() {
            if (this.permissions.includes('*') || this.permissions.includes('023')) {
                return true
            } else {
                return false
            }
        },
        permissions_delete() {
            if (this.permissions.includes('*') || this.permissions.includes('024')) {
                return true
            } else {
                return false
            }
        },
        users() {
            return this.$store.state.userManagement.users
        },
        groupid_list() {
            let self = this
            let temp = []

            this.users.forEach(function (item) {
                if (item.role !== 'WORKER') {
                    temp.push({
                        groupid: item.groupid,
                        name: item.name
                    })
                }
            })

            return temp
        },
        user_info() {
            let data = JSON.parse(sessionStorage.getItem('userInfo'));
            return data
        },
        queriedItems() {
            return this.$refs.table ? this.$refs.table.queriedResults.length : this.filter_customers.length
        }
    },
    watch: {
        filter_customers() {
            this.checkThis()
        }
    },
    methods: {
        checkFlag(pictures) {
            if (pictures && pictures !== '' && pictures.length > 0) {
                return true
            } else return false
        },
        checkImageUrl(pictures) {
            if (pictures && pictures !== '' && pictures.length > 0) {
                return pictures[0].url
            } else return false
        },
        parentImageUpdated(event) {
            this.fetchCustomers()
        },
        getImage(event, customer_uuid) {
            const file = event.target.files[0];
            if (file) {
                const formData = new FormData();
                formData.append('customer_uuid', customer_uuid); // Add customer_uuid
                formData.append('customer_picture', file); // Add file as loan_picture
                formData.append('file[0]', file); // Add file as file[0]

                this.uploadImage(formData);
            }
        },
        uploadImage(formData) {
            let obj = {
                form_data: formData
            }

            console.log(formData, 'uploading image...');
            this.$store.dispatch('customerManagement/addCustomerImage', obj).then((data) => {
                console.log(data);
                this.fetchCustomers()
            })
        },
        formatGroup(id) {
            let temp = ''
            this.groupid_list.forEach(function (item) {
                // console.log(item, id)
                if (item.groupid == id) {
                    temp = item.name
                }
            })
            return temp
        },
        checkThis() {
            let self = this
            if (this.$route.params.customer_id && this.$route.params.customer_id !== '') {
                this.filter_customers.forEach(function (item) {
                    if (item.uuid == self.$route.params.customer_id) {
                        self.editData(item)
                    }
                })
            }
        },
        addNewData() {
            this.sidebarData = {}
            this.toggleDataSidebar(true)
        },
        editData(data) {
            // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
            this.sidebarData = data
            this.toggleDataSidebar(true)
        },
        deleteCustomer(customer) {
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: 'Confirm Delete',
                text: `Are you sure you want to delete customer "${customer.name}"? This action cannot be undone.`,
                accept: () => this.confirmDelete(customer),
                acceptText: 'Delete',
                cancelText: 'Cancel'
            })
        },
        confirmDelete(customer) {
            this.$vs.loading()
            this.$store.dispatch('customerManagement/deleteCustomer', { uuid: customer.uuid })
                .then(() => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        iconPack: 'feather',
                        icon: 'icon-check-circle',
                        color: 'success',
                        title: 'Success',
                        text: 'Customer deleted successfully'
                    })
                    this.fetchCustomers()
                })
                .catch(err => {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                        title: 'Error',
                        text: err.message || 'Failed to delete customer'
                    })
                })
        },
        toggleDataSidebar(val = false) {
            this.addNewDataSidebar = val
        },
        fetchCustomers() {
            let formData = new FormData()
            formData.append('val', '')
            formData.append('status', 'ACTIVE,INACTIVE')
            let obj = {
                form_data: formData
            }
            this.$vs.loading()
            this.$store.dispatch('customerManagement/fetchCustomers', obj).then((data) => {
                this.$vs.loading.close()
            }).catch(err => {
                if (err.logout) {
                    this.$vs.loading.close()
                    this.$vs.notify({
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger',
                        title: err.msg
                    })
                    sessionStorage.removeItem('accessToken')
                    sessionStorage.removeItem('user')
                    sessionStorage.removeItem('loan_info')
                    this.$router.push('/pages/login').catch(() => {})
                }
                console.error(err, 'customerManagement/fetchCustomers')
            })
        }
    },
    created() {
        let self = this
        if (!moduleCustomerManagement.isRegistered) {
            this.$store.registerModule('customerManagement', moduleCustomerManagement)
            moduleCustomerManagement.isRegistered = true
        }

        if (this.permissions_list) {
            this.fetchCustomers()
        }
    },
    mounted() {
        this.isMounted = true
    },
    beforeRouteLeave(to, from, next) {
        console.log('beforeRouteLeave1', this.addNewDataSidebar)
        this.sidebarData = {}
        this.addNewDataSidebar = false
        console.log('beforeRouteLeave2', this.addNewDataSidebar)

        setTimeout(function () {
            next()
        }, 100)
    },
    beforeDestroy() {
        console.log('Main Vue destroyed')
        this.sidebarData = {}
        this.addNewDataSidebar = false
    }
}
</script>

<style lang="scss">
#data-list-list-view {
    .vs-con-table {

        /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
        @media (max-width: 689px) {
            .vs-table--search {
                margin-left: 0;
                max-width: unset;
                width: 100%;

                .vs-table--search-input {
                    width: 100%;
                }
            }
        }

        @media (max-width: 461px) {
            .items-per-page-handler {
                display: none;
            }
        }

        @media (max-width: 341px) {
            .data-list-btn-container {
                width: 100%;

                .dd-actions,
                .btn-add-new {
                    width: 100%;
                    margin-right: 0 !important;
                }
            }
        }

        .product-name {
            max-width: 23rem;
        }

        .vs-table--header {
            display: flex;
            flex-wrap: wrap;
            margin-left: 1.5rem;
            margin-right: 1.5rem;

            >span {
                display: flex;
                flex-grow: 1;
            }

            .vs-table--search {
                padding-top: 0;

                .vs-table--search-input {
                    padding: 0.9rem 2.5rem;
                    font-size: 1rem;

                    &+i {
                        left: 1rem;
                    }

                    &:focus+i {
                        left: 1rem;
                    }
                }
            }
        }

        .vs-table {
            border-collapse: separate;
            border-spacing: 0 1.3rem;
            padding: 0 1rem;

            tr {
                box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

                td {
                    padding: 20px;

                    &:first-child {
                        border-top-left-radius: .5rem;
                        border-bottom-left-radius: .5rem;
                    }

                    &:last-child {
                        border-top-right-radius: .5rem;
                        border-bottom-right-radius: .5rem;
                    }
                }

                td.td-check {
                    padding: 20px !important;
                }
            }
        }

        .vs-table--thead {
            th {
                padding-top: 0;
                padding-bottom: 0;

                .vs-table-text {
                    text-transform: uppercase;
                    font-weight: 600;
                }
            }

            th.td-check {
                padding: 0 15px !important;
            }

            tr {
                background: none;
                box-shadow: none;
            }
        }

        .vs-table--pagination {
            justify-content: center;
        }
    }
}
</style>
